import React from 'react';

import PropTypes from 'prop-types';

import ConfirmPopup from './ConfirmPopup';
import IconButton from './IconButton';

class ChangeStatusButton extends React.Component {
  render() {
    const { onSetPendingStatus, onSetPaidStatus, hide, header, ...props } = this.props;

    return (
      <ConfirmPopup 
         onConfirm={ onSetPaidStatus } 
         onCancel={ onSetPendingStatus } 
         header={ header || 'Change Status' } 
         cancelIcon={'undo alternate'}
         okIcon={'dollar sign'} 
         oktext='Paid' 
         canceltext='Pending' 
         on='click'>
        <IconButton name='clipboard check' color='green' className={ 'approval-button' + (hide ? ' hidden' : '') } { ...props } popup='Mark as Paid / Pending'/>
      </ConfirmPopup>
    );
  }
};

ChangeStatusButton.propTypes = {
  onSetPendingStatus: PropTypes.func.isRequired,
  onSetPaidStatus: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  header: PropTypes.string,
  hide: PropTypes.bool,
};

export default ChangeStatusButton;
